import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  sync(event) {
    if (window.tinymce) {
      console.log("[BlogForm] Syncing TinyMCE content before submit")
      tinymce.triggerSave()
    }
  }
}